// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"ZT-z","inlineTitle":"_T-z","sponsoredAdsWrapper":"aU-z","marketplaceRecosWrapper":"bU-z"};